/** The existing AppNotes home link shared by console and guest entry. */
export function Brand() {
  return (
    <a className="brand" href="/" aria-label="AppNotes home">
      <svg
        aria-hidden="true"
        className="exact-point-mark"
        shapeRendering="geometricPrecision"
        viewBox="0 0 24 24"
      >
        <path
          d="M9 3H3V9M15 3H21V9M3 15V21H9M21 15V21H15"
          fill="none"
          stroke="currentColor"
          strokeLinecap="square"
          strokeLinejoin="miter"
          strokeWidth="2"
        />
        <circle className="exact-point-registration" cx="12" cy="12" r="2" />
      </svg>
      <strong>AppNotes</strong>
    </a>
  );
}
